import en from "./en.json";
import ru from "./ru.json";
import tr from "./tr.json";
import es from "./es.json";
import pl from "./pl.json";
import id from "./id.json";
import it from "./it.json";
import pt from "./pt.json";
import ms from "./ms.json"; // Название переменной валидное
import ar from "./ar.json";

export const defaultLocale = "en";

export const languages = {
  en,
  ru,
  tr,
  es,
  pl,
  id,
  it,
  pt,
  ms,
  ar,
};
